/* 이 프로젝트에서 사용할 axios 인스턴스의 설정 */
import axios from 'axios'

const cancelToken = axios.CancelToken
const source = cancelToken.source()

export const baseURL = process.env.NODE_ENV === 'production'
  ? 'https://subuleasy.co.kr'
  : 'http://localhost:8080';

/* 새 인스턴스 설정 */
const client = axios.create({
  baseURL,
  withCredentials: true,
  cancelToken: source.token
})
client.defaults.headers.post['Content-Type'] = 'application/json'
client.defaults.headers.common['Access-Control-Allow-Origin'] = baseURL

export default client